import React, { useEffect, useRef, useState, memo } from 'react';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

import {
  Box,
  LinearProgress,
} from '@material-ui/core';


function ExportExcel(props) {

  const [headerList, setHeaderList] = useState([]);
  const [bodyList, setBodyList] = useState([]);
  const [fileName, setFileName] = useState('');
  const [isExporting, setIsExporting] = useState(false);
  const buttonWrapperRef = useRef(null);
  const timeoutRef = useRef(null);

  useEffect(() => {
    setHeaderList(props.headerList);
    setBodyList(props.bodyList);
    setFileName(props.fileName);
  }, [props.headerList, props.bodyList, props.fileName]);

  useEffect(() => {
    const wrapper = buttonWrapperRef.current;
    if (!wrapper) {
      return undefined;
    }
    const button = wrapper.querySelector('button');
    if (!button) {
      return undefined;
    }

    const handleClick = () => {
      setIsExporting(true);
      button.disabled = true;
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(() => {
        setIsExporting(false);
        button.disabled = false;
      }, 1200);
    };

    button.addEventListener('click', handleClick);

    return () => {
      button.removeEventListener('click', handleClick);
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <Box>
      <i className="fas fa-external-link-alt homeExportCasesLink"></i>
      <div ref={buttonWrapperRef}>
        <ReactHTMLTableToExcel
          id="test-table-xls-button"
          className="download-table-xls-button"
          table="table-to-xls"
          filename={fileName}
          sheet="Resultado"
          buttonText="Exportar arquivo XLS" />
      </div>
      {isExporting && (
        <Box mt={1}>
          <LinearProgress />
        </Box>
      )}
      <Box hidden>
        <table id="table-to-xls">
          <thead>
            <tr>
              {headerList && headerList.length > 0 &&
                headerList.map((elHeader, index) => {
                  return (<th key={index}>{elHeader}</th>)
                })
              }
            </tr>
          </thead>
          <tbody>
            {bodyList && bodyList.length > 0 &&
              bodyList.map((elBody, index) => {
                return (<tr key={index}>
                  {
                    Object.keys(elBody).map((key, index) => {
                      return (
                        <td key={index}>{elBody[key]}</td>
                      )
                    })
                  }
                </tr>)
              })
            }
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

export default memo(ExportExcel);
